import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import IProductType from './IProductType';
import DeleteButton from '../../components/common/DeleteButton';

interface ProductTypeListRowProps {
    productType: any;
    key: number;
    beginEdit: (id: number) => void;
    delete: (id: number) => void;
    showLogs: (id: number) => void;
}

const ProductTypeListRow = (props: ProductTypeListRowProps) => {
    return (
        <tr>
            <td>{props.productType.name}</td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <DeleteButton
                        onDelete={() => props.delete(props.productType.id)}
                        text={Translate('product-types/list/row/delete/remove-this-product-type')}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('product-types/list/row/button-label/delete')}
                    </DeleteButton>
                    <Button
                        onClick={props.beginEdit.bind(null, props.productType.id)}
                        bsStyle="primary"
                    >
                        {' '}
                        <i className="material-icons">edit</i>{' '}
                        {Translate('product-types/list/row/button-label/edit')}
                    </Button>
                    <Button
                        onClick={props.showLogs.bind(null, props.productType.id)}
                        bsStyle="default"
                    >
                        <i className="material-icons">list</i>{' '}
                        {Translate('product-types/list/row/button-label/logs')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default ProductTypeListRow;
